import { api } from "@/lib/api-client";
import type { MediaFilters, MediaItem, PaginatedResponse, UpdateMediaInput } from "./types";

function listPath(filters: MediaFilters) {
  const params = new URLSearchParams({
    page: String(filters.page ?? 1),
    pageSize: String(filters.pageSize ?? 24),
  });
  if (filters.search) params.set("search", filters.search);
  return `/media?${params.toString()}`;
}

export const mediaApi = {
  list: (filters: MediaFilters) => api.get<PaginatedResponse<MediaItem>>(listPath(filters)),
  upload: (files: File[]) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    return api.post<MediaItem[]>("/media/upload", formData);
  },
  update: (id: string, input: UpdateMediaInput) => api.patch<MediaItem>(`/media/${id}`, input),
  delete: (id: string) => api.delete<void>(`/media/${id}`),
};
